"use client";

import React from "react";
import Image, { type StaticImageData } from "next/image";

interface ServiceCardProps {
  title?: string;
  description?: string;
  icon?: string | StaticImageData;
  icondark?: string | StaticImageData;
  link?: string;
  darkMode?: boolean;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  icon,
  icondark,
  link,
}) => {
  const href =
    link && process.env.NEXT_PUBLIC_BASE_URL
      ? `${process.env.NEXT_PUBLIC_BASE_URL}${link}`
      : (link ?? "#");

  return (
    <a
      href={href}
      className="service-box group box p-[var(--service-card-padding)] bg-white relative overflow-hidden cursor-pointer transition-colors duration-300"
    >
      {/* Icon */}
      {(icon || icondark) && (
        <div className="relative size-[66px] z-[2]">
          {icon && (
            <Image
              src={icon}
              alt={`${title ?? "service"} icon`}
              width={66}
              height={66}
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="absolute inset-0 size-full transition-opacity duration-300 group-hover:opacity-0"
            />
          )}
          {icondark && (
            <Image
              src={icondark}
              alt={`${title ?? "service"} icon dark`}
              width={66}
              height={66}
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="absolute inset-0 size-full opacity-0 transition-opacity duration-300 group-hover:opacity-100"
            />
          )}
        </div>
      )}

      {/* Title */}
      <h3 className="max-w-[14ch] pt-[60px] pb-[10px] font-medium clash-font capitalize leading-[140%] relative z-[2] transition-colors duration-300 text-[#00040b] group-hover:text-white text-[length:var(--section-subtitle)]">
        {title}
      </h3>

      {/* Description */}
      <div className="text-[length:var(--service-card-description)] font-medium w-full lg:max-w-[37ch] relative z-[2] transition-colors duration-300 text-[#636363] group-hover:text-white">
        {description}
      </div>

      {/* Animated Background Circle */}
      <div className="service-circle absolute top-[-80px] left-[-80px] size-[80px] bg-[#225BD4] rounded-full z-[1] transition-transform duration-500 ease-out will-change-transform scale-1 group-hover:scale-[25]" />
    </a>
  );
};

export default ServiceCard;
